/* eslint-disable camelcase */

import { getDefaultStatisticItem } from '../../utils/utils'

const possessionEvents = ['SAFE_ZONE', 'ATTACK', 'POSESSION_1', 'POSESSION_2']
const zonesByTeamSide = {
  1: {
    notReversed: {
      0: 'defense',
      2: 'center',
      4: 'attack'
    },
    reversed: {
      0: 'attack',
      2: 'center',
      4: 'defense'
    }
  },
  2: {
    reversed: {
      0: 'defense',
      2: 'center',
      4: 'attack'
    },
    notReversed: {
      0: 'attack',
      2: 'center',
      4: 'defense'
    }
  }
}
let previousActiveSide = null
let previousPlayTime = null
let prevZone

export default {
  statisticScheme: {
    possession: getDefaultStatisticItem('statistic.poss', { inPercents: true,  editable: false }),
    possession_attack: getDefaultStatisticItem('statistic.poss.attack', { percentFrom: 'possession' }),
    possession_center: getDefaultStatisticItem('statistic.poss.center', { percentFrom: 'possession' }),
    possession_defense: getDefaultStatisticItem('statistic.poss.defense', { statisticFunction: defenseStatisticFunction.toString() }),
    'CORNER_KICK': getDefaultStatisticItem('statistic.cornerKick'),
    'CORNER_1': getDefaultStatisticItem(),
    'CORNER_2': getDefaultStatisticItem(),
    'CORNER_3': getDefaultStatisticItem(),
    'CORNER_4': getDefaultStatisticItem(),
    'RED_CARD': getDefaultStatisticItem('statistic.redCard'),
    'YELLOW_CARD': getDefaultStatisticItem('statistic.yellowCard'),
    'SECOND_YELLOW_CARD': getDefaultStatisticItem()
  },
  statisticEvents: {
    'CORNER_KICK': 'CORNER_KICK',
    'CORNER_1': 'CORNER_1',
    'CORNER_2': 'CORNER_2',
    'CORNER_3': 'CORNER_3',
    'CORNER_4': 'CORNER_4',
    'YELLOW_CARD': ['YELLOW_CARD', 'SECOND_YELLOW_CARD'],
    'SECOND_YELLOW_CARD': 'SECOND_YELLOW_CARD',
    'RED_CARD': ['RED_CARD', 'SECOND_YELLOW_CARD']
  },
  statisticOrder: [
    'possession',
    'possession_attack',
    'possession_center',
    'possession_defense',
    'CORNER_KICK',
    'RED_CARD',
    'YELLOW_CARD',
    'SECOND_YELLOW_CARD'
  ],
  customStatisticEvents: [
    'GOAL',
    'CORNER_KICK',
    'YELLOW_CARD',
    'SECOND_YELLOW_CARD',
    'RED_CARD',
    'PENALTY_CONFIRMED',
    'OFFSIDE',
    'FOUL',
    'FREE_KICK',
    'DANGEROUS_FREE_KICK',
    'ATTACK',
    'SUBSTITUTION'
  ],
  statisticFunction (event) {
    getCommonPossessionStatistic.bind(this)(event)
    updateZone.bind(this)(event)
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}

const getZoneTitle = (event, isReversedField) => {
  const { extra: { zone }, TeamNumber } = event
  const reverseOption = isReversedField ? 'reversed' : 'notReversed'

  return zonesByTeamSide[TeamNumber][reverseOption][zone]
}

function updateZone (event) {
  const { getIngameData } = this
  const { isReversedField } = getIngameData
  const { EventCode } = event
  const needToChangeZone = possessionEvents.includes(EventCode)

  if (needToChangeZone) {
    prevZone = getZoneTitle(event, isReversedField)
  }
}

function defenseStatisticFunction (team) {
  const { statistic } = this
  const { possession, possession_attack, possession_center } = statistic
  const attack = Math.round(possession_attack[team] / possession[team] * 100)
  const center = Math.round(possession_center[team] / possession[team] * 100)
  const val = 100 - attack - center
  const value = isNaN(val) || val < 0 ? '0%' : `${val}%`

  return { value, percent: value }
}

function updateFunction ({ period, team, type, value }) {
  this.updateStatistic({
    statisticType: 'defaultStatistic',
    property: 'possession',
    period,
    team,
    type,
    value
  })

  if (prevZone !== 'defense' && ['attack', 'center'].includes(prevZone)) {
    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: `possession_${prevZone}`,
      period,
      team,
      type,
      value
    })
  }
}

function getCommonPossessionStatistic (event) {
  const updateStatistic = updateFunction.bind(this)
  const {
    isTimerStoped,
    getActiveSide,
    getMatchPeriods,
    getCurrentPeriod
  } = this

  if (!getCurrentPeriod) return

  const { EventCode, Playtime, GamePeriod } = event
  const { overriddenType } = getMatchPeriods[getCurrentPeriod]

  if (!getActiveSide && !previousActiveSide) return

  if (EventCode === 'START_PERIOD' || overriddenType === 'shootout') {
    previousPlayTime = Playtime

    return
  }

  if (EventCode === 'STOP_GAME_CLOCK') {
    updateStatistic({
      type: 'increment',
      period: GamePeriod || getCurrentPeriod,
      team: previousActiveSide,
      value: Playtime - previousPlayTime
    })
  }

  if (isTimerStoped) {
    previousPlayTime = Playtime

    return
  }

  if (previousActiveSide !== getActiveSide) {
    if (previousActiveSide) {
      updateStatistic({
        period: GamePeriod || getCurrentPeriod,
        team: previousActiveSide,
        type: 'increment',
        value: Playtime - previousPlayTime
      })
    }

    previousActiveSide = getActiveSide
    previousPlayTime = Playtime

    return
  }

  updateStatistic({
    period: GamePeriod || getCurrentPeriod,
    team: getActiveSide,
    type: 'increment',
    value: Playtime - previousPlayTime
  })

  previousPlayTime = Playtime
}
